import React from 'react';

import { Button, DatePicker, Flex, Popover } from 'antd';
import { ClockCircleOutlined, EditOutlined } from '@ant-design/icons';
import useOccurrences from 'src/pages/dashboard/contexts/useOccurrences';
import {
	CardData,
	CardTitle,
	IconArea
} from 'src/pages/dashboard/components/cards/styles';
import dayjs from 'dayjs';

export default function PeriodDisplay() {
	const { period, setOccurrencesPeriod, } = useOccurrences();

	const startDate = dayjs(period.inf_date).format('DD/MM/YY');
	const endDate = dayjs(period.sup_date).format('DD/MM/YY');

	return (
		<Flex
			gap={16}
			justify='space-between'
			style={{ width: '100%', }}
		>
			<Flex vertical gap={4}>
				<CardTitle>
					<Popover
						content={
							<Flex vertical gap={8}>
								<p>Informe um período:</p>
								<DatePicker.RangePicker
									onChange={(dates) => {
										if(dates === null) return;
										const inf_date = dates[0];
										const sup_date = dates[1];

										if(!inf_date || !sup_date) return;
										setOccurrencesPeriod(inf_date, sup_date);
									}}
									maxDate={dayjs()}
									format={'DD/MM/YY'}
									value={[
										dayjs(period.inf_date),
										dayjs(period.sup_date),
									]}
								/>
							</Flex>
						}
						trigger="click"
					>
						<Button
							size='small'
							type='text'
							icon={<EditOutlined />}
						/>
					</Popover>
                    
					Período:
				</CardTitle>
				<CardData
					style={{
						fontSize: '16px',
					}}
				>
					{`${startDate} ~ ${endDate}`}
				</CardData>
			</Flex>
			<IconArea>
				<ClockCircleOutlined style={{ fontSize: 24, color: '#fff', }} />
			</IconArea>
		</Flex>
	);
}
